import React, { useState, useRef, useEffect } from "react";
import { FaCalendar } from "react-icons/fa6";
import { FaTimes } from "react-icons/fa";
import "./Modal.css";
import { useSelector } from "react-redux";
import { downloadComplaintsReport } from "../../../config/LiveApi";
import { toast } from "react-toastify";
import { DateRangePicker } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";

const DownloadReportModal = ({ onClose }) => {
  const token = useSelector((store) => store.userReducer.token);
  const pickerRef = useRef();

  const [showPicker, setShowPicker] = useState(false);
  const [tempRange, setTempRange] = useState({
    startDate: new Date(new Date().setHours(0, 0, 0, 0)),
    endDate: new Date(new Date().setHours(23, 59, 59, 999)),
    key: "selection",
  });

  const [selectedRange, setSelectedRange] = useState(tempRange);

  const handleSelect = (ranges) => {
    setTempRange(ranges.selection);
  };

  const handleApply = () => {
    setSelectedRange(tempRange);
    setShowPicker(false);
  };

  const handleClickOutside = (e) => {
    if (pickerRef.current && !pickerRef.current.contains(e.target)) {
      setShowPicker(false);
    }
  };

  useEffect(() => {
    if (showPicker) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [showPicker]);

  const handleDownload = async () => {
    const formattedStart = selectedRange.startDate.toISOString();
    // const formattedEnd = selectedRange.endDate.toISOString();
    const adjustedEndDate = new Date(selectedRange.endDate);
    adjustedEndDate.setDate(adjustedEndDate.getDate() + 1);
    const formattedEnd = adjustedEndDate.toISOString();
    // console.log("formattedStart",formattedStart)
    // console.log("formattedEnd",formattedEnd)

    try {
      const response = await downloadComplaintsReport(
        token,
        formattedStart,
        formattedEnd
      );
      const blob = new Blob([response], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "complaints_report.xlsx");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      toast.success("Report downloaded successfully");
      onClose();
    } catch (err) {
      toast.error("Failed to download report");
      console.error(err);
    }
  };

  return (
    <div className="download-modal-overlay">
      <div className="download-modal-content">
        <button onClick={onClose} className="download-modal-buttons-close">
          <FaTimes size={25} />
        </button>

        <h2 className="text-heading-download">
          Download Complaints Report
        </h2>

        <div className="select-date-range-calendar">
          <div className="select-date-text">
            Selected Range :{" "}
            <spna className="selected-date-text">
              {selectedRange.startDate.toLocaleDateString("en-GB")} -{" "}
              {selectedRange.endDate.toLocaleDateString("en-GB")}
            </spna>
          </div>
        </div>
        <div className="calender-div">
          <div className="calendar-toggle-text">
            <p>Select Date:</p>
          </div>

          <div className="calendar-toggle-button">
            <button onClick={() => setShowPicker(!showPicker)}>
              <FaCalendar />
            </button>
          </div>
        </div>

        {showPicker && (
          <div className="calendar-picker-wrapper" ref={pickerRef}>
            <DateRangePicker
              ranges={[tempRange]}
              onChange={handleSelect}
              maxDate={new Date()}
              editableDateInputs={true}
            />
            <div>
              <button className="calendar-apply-button" onClick={handleApply}>
                Apply
              </button>
            </div>
          </div>
        )}

        <div className="download-modal-buttons-recon">
          <button
            onClick={handleDownload}
            className="download-modal-buttons-download"
          >
            Download
          </button>
        </div>
      </div>
    </div>
  );
};

export default DownloadReportModal;
